import { create } from "zustand";

export enum EditPanelType {
  Dimensions = "dimensions",
  Zones = "zones",
}

interface EditPanelState {
  activePanel: EditPanelType | null;
  openPanel: (panel: EditPanelType) => void;
  closePanel: () => void;
}

export const EditPanelStore = create<EditPanelState>((set) => ({
  activePanel: null,
  openPanel: (panel) => set({ activePanel: panel }),
  closePanel: () => set({ activePanel: null }),
}));
